// export const initialServices = [
//   {
//     id: 1,
//     title: "Mutual Funds Investment",
//     description: "Professional mutual fund advisory with personalized portfolio management. Get higher returns with expert guidance.",
//     icon: "📈",
//     image: "https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?w=500",
//     features: ["SIP & Lumpsum Options", "Tax Saving ELSS Funds", "Large/Mid/Small Cap Funds", "Regular Portfolio Review"],
//     benefits: ["Higher Returns than FD", "Professional Management", "Tax Benefits under 80C", "Start with ₹500"],
//     type: "mutual-fund",
//     isActive: true
//   },
//   {
//     id: 2,
//     title: "Health Insurance",
//     description: "Comprehensive health insurance plans to protect you and your family from medical expenses.",
//     icon: "🏥",
//     image: "https://images.unsplash.com/photo-1579684385127-1ef15d508118?w=500",
//     features: ["Cashless Treatment", "Critical Illness Cover", "Family Floater Plans", "No Claim Bonus"],
//     benefits: ["Tax Benefits under 80D", "Sum Insured up to 1 Cr", "Lifetime Renewal", "Pre-existing Disease Cover"],
//     type: "insurance",
//     isActive: true
//   },
//   {
//     id: 3,
//     title: "Life Insurance",
//     description: "Secure your family's future with our comprehensive life insurance solutions.",
//     icon: "🛡️",
//     image: "https://images.unsplash.com/photo-1556742502-ec7c0e9f34b1?w=500",
//     features: ["Term Insurance", "Whole Life Plans", "Money Back Policies", "Child Plans"],
//     benefits: ["Financial Security", "Tax Benefits", "Wealth Creation", "Rider Options"],
//     type: "insurance",
//     isActive: true
//   },
//   {
//     id: 4,
//     title: "Retirement Planning",
//     description: "Plan your golden years with our customized retirement solutions.",
//     icon: "👴",
//     image: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=500",
//     features: ["Pension Plans", "NPS Investment", "Annuity Options", "Retirement Corpus Calculator"],
//     benefits: ["Regular Monthly Income", "Tax Benefits", "Inflation Protection", "Financial Independence"],
//     type: "financial-planning",
//     isActive: true
//   },
//   {
//     id: 5,
//     title: "Home Loans",
//     description: "Make your dream home a reality with our affordable home loan solutions.",
//     icon: "🏠",
//     image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=500",
//     features: ["Low Interest Rates", "Flexible Tenure", "Quick Approval", "Balance Transfer"],
//     benefits: ["Tax Benefits on Interest", "Low EMI Options", "Minimal Documentation", "Top-up Loan Available"],
//     type: "loan",
//     isActive: true
//   },
//   {
//     id: 6,
//     title: "Car & Bike Insurance",
//     description: "Comprehensive vehicle insurance with 24/7 claim assistance.",
//     icon: "🚗",
//     image: "https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?w=500",
//     features: ["Third-party Cover", "Comprehensive Plans", "Zero Depreciation", "24/7 Roadside Assistance"],
//     benefits: ["Quick Claim Settlement", "No Claim Bonus", "Cashless Garages", "Renewal Reminders"],
//     type: "insurance",
//     isActive: true
//   },
//   {
//     id: 7,
//     title: "Fixed Deposits",
//     description: "Safe and secure investment options with guaranteed returns.",
//     icon: "💰",
//     image: "https://images.unsplash.com/photo-1589578228447-e1a4e481c6c8?w=500",
//     features: ["High Interest Rates", "Flexible Tenure", "Cumulative/Non-cumulative", "Senior Citizen Benefits"],
//     benefits: ["Guaranteed Returns", "Low Risk", "Liquidity Options", "Tax Saving FD Available"],
//     type: "financial-planning",
//     isActive: true
//   },
//   {
//     id: 8,
//     title: "Tax Planning",
//     description: "Smart tax saving strategies to maximize your savings.",
//     icon: "📋",
//     image: "https://images.unsplash.com/photo-1554224154-26032ffc0f07?w=500",
//     features: ["80C Investments", "Health Insurance Deductions", "Home Loan Benefits", "NPS Contributions"],
//     benefits: ["Save up to ₹46,800 Tax", "Legal Tax Exemptions", "Long-term Wealth", "Compliance Support"],
//     type: "financial-planning",
//     isActive: true
//   }
// ];

export const initialServices = [
  {
    id: 1,
    title: "Mutual Funds",
    description:
      "Professional mutual fund guidance focused on disciplined investing, portfolio growth, and long-term financial success.",

    icon: "📈",

    image:
      "https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?w=500",

    features: [
      "SIP & Lumpsum Investment",
      "Wealth Creation",
      "Goal Planning",
      "Diversified Portfolio",
      "Smart Asset Allocation",
      "Education Planning",
      "Marriage Planning",
      "Retirement Planning",
      "Child Future Planning",
      "Long-Term Financial Growth",
      "Financial Freedom Planning",
      "Risk Management Strategy",
      "Customized Investment Solutions",
    ],

    type: "mutual-fund",
    isActive: true,
  },

  {
    id: 2,
    title: "Health Insurance",

    description:
      "Get expert guidance to choose the right health insurance plan for financial protection, peace of mind, and better healthcare support.",

    icon: "🏥",

    image:
      "https://images.unsplash.com/photo-1579684385127-1ef15d508118?w=500",

    features: [
      "Financial Protection During Medical Emergencies",
      "Coverage Against Expensive Hospital Bills",
      "Secure Your Family’s Health & Future",
      "Reduce Financial Stress During Crisis",
      "Cashless Hospitalization Support",
      "Protection from Unexpected Healthcare Costs",
      "Peace of Mind for You & Your Family",
      "Emergency Medical Assistance Coverage",
      "Affordable Healthcare Security Plans",
      "Support for Critical Illness & Treatments",
    ],

    type: "insurance",
    isActive: true,
  },

  {
    id: 3,
    title: "Life Insurance",

    description:
      "Expert life insurance guidance to help you build long-term protection and financial confidence for your family.",

    icon: "🛡️",

    image:
      "https://images.unsplash.com/photo-1556742502-ec7c0e9f34b1?w=500",

    features: [
      "Financial Protection for Family",
      "Long-Term Financial Security",
      "Life Cover Against Uncertainties",
      "Wealth Creation & Savings Benefits",
      "Tax Saving Benefits Under Applicable Laws",
      "Flexible Premium Payment Options",
      "Goal-Based Financial Planning",
      "Child Education & Future Planning",
      "Retirement & Pension Support",
      "Bonus & Guaranteed Benefits in Select Plans",
      "Peace of Mind for You & Your Loved Ones",
      "Customizable Coverage as Per Your Needs",
      "Protection Against Income Loss",
    ],

    type: "insurance",
    isActive: true,
  },

  {
    id: 4,
    title: "Home Loans",

    description:
      "Make your dream home a reality with affordable and flexible home loan solutions tailored to your financial needs.",

    icon: "🏠",

    image:
      "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=500",

    features: [
      "Low Interest Rates",
      "Flexible Tenure",
      "Quick Approval Process",
      "Balance Transfer Facility",
      "Low EMI Options",
      "Minimal Documentation",
      "Top-up Loan Available",
      "Expert Loan Assistance",
    ],

    type: "loan",
    isActive: true,
  },

  {
    id: 5,
    title: "Car & Bike Insurance",

    description:
      "Protect your vehicle with comprehensive insurance solutions and fast claim assistance support.",

    icon: "🚗",

    image:
      "https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?w=500",

    features: [
      "Third-party Cover",
      "Comprehensive Protection",
      "Zero Depreciation Plans",
      "24/7 Roadside Assistance",
      "Quick Claim Settlement",
      "Cashless Garage Support",
      "No Claim Bonus Benefits",
      "Renewal Reminder Assistance",
    ],

    type: "insurance",
    isActive: true,
  },
];